<template>
    <span class="profile-strategy-badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" fill="none" viewBox="0 0 16 21">
            <rect width="16" height="21" fill="#0e0e0e" rx="8" />
            <path
                fill="var(--joy-color-neutral-20)"
                d="M8.084 17q-1.514 0-2.654-.519-1.14-.518-1.776-1.469-.635-.951-.654-2.213l2.916-.432q0 1.089.654 1.746.653.657 1.664.657.803 0 1.29-.398.504-.398.504-1.02 0-.517-.392-.864-.374-.363-1.234-.64l-1.626-.484Q5 10.862 4.196 10q-.785-.865-.785-2.282 0-1.677 1.178-2.697T7.897 4q1.982 0 3.197 1.003 1.215.985 1.252 2.68l-2.841.5q.018-.899-.449-1.434-.466-.554-1.215-.554-.654 0-1.065.38a1.19 1.19 0 0 0-.412.934q0 .555.374.917.393.345 1.271.587l1.552.484q1.813.502 2.617 1.366.822.848.822 2.265 0 1.123-.58 2.005t-1.682 1.383Q9.635 17 8.084 17"
            />
        </svg>
    </span>
</template>

<style scoped lang="scss">
    .profile-strategy-badge {
        display: inline-block;
        width: 16px;
        height: 21px;
        flex-shrink: 0;
    }
</style>
